<template>
  <div class="component-video" :style="width ? `--width: ${width}px;` : ''">
    <div v-if="!src" class="player-container">
      <VideoButton
        v-if="playerButtonIsVisible"
        class="play-button"
        style="--primary: #ff5a5f"
        @click="() => handlePlayButton()"
      />
      <video
        ref="videoPlayer"
        preload="none"
        width="900"
        height="500"
        class="native-player"
        :poster="options.poster"
        :playsinline="playsinline"
      >
        <source
          v-for="(item, index) in options.sources"
          :key="index"
          :src="item.src"
          :type="item.type"
        />
        {{ $t('main.ui.video.yourBrowserDoesNotSupportTheVideoTag') }}
      </video>
    </div>
    <div v-else class="embed-responsive embed-responsive-16by9">
      <iframe
        width="838"
        height="470"
        class="video-player-box overflow-hidden rounded embed-responsive-item"
        :src="src"
        frameborder="0"
        :title="$t('main.ui.video.youtubePlayer')"
      ></iframe>
    </div>
  </div>
</template>

<script>
import VideoButton from './VideoButton.vue';
export default {
  name: 'Video',
  components: {
    VideoButton
  },
  props: {
    path: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Object,
      required: false,
      default: function () {
        return {
          language: 'en',
          playbackRates: [1.0],
          sources: [
            {
              type: 'video/mp4',
              src: 'https://images.vexels.com/files/web/assets/meet-vexels.mp4'
            }
          ],
          poster: 'https://cdn.vexels.com/img/preview-video-vexels.jpg'
        };
      }
    },
    classes: {
      type: String,
      default: ''
    },
    playsinline: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      playerButtonIsVisible: true
    };
  },
  computed: {
    src() {
      return this.path ? 'https://www.youtube.com/embed/' + this.path : '';
    }
  },
  methods: {
    handlePlayButton() {
      this.$refs.videoPlayer.setAttribute('controls', 'controls');
      this.$refs.videoPlayer.play();
      this.playerButtonIsVisible = false;
    }
  }
};
</script>

<style lang="scss">
.component-video {
  max-width: var(--width);
  margin: 0 auto;
  .player-container {
    width: 100%;
    padding-top: 56.25%;
    height: 0px;
    position: relative;
    margin: 0 auto;
  }
  .native-player {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .play-button {
    z-index: 1;
    position: absolute;
    top: calc(50% - 36px);
    left: calc(50% - 36px);
  }
}
</style>
